import { AthleteProfilePageProps } from "./types";
import { Heading, Paragraph, Link } from "@digdir/designsystemet-react";

export function AthleteProfilePage(props: AthleteProfilePageProps) {
  const {
    profileImage,
    club,
    team,
    sex,
    birthDate,
    homeTown,
    residentTown,
    fisAthleteId,
    fisAthleteSectorValue,
    jobTitle,
    email,
    phoneNumber,
    photoCredit,
    translation,
  } = props;

  return (
    <div className="content px-4 lg:px-3 2xl:px-2 mb-4">
      {profileImage?.url && (
        <div className="mb-6">
          <img
            src={profileImage.url}
            alt={profileImage.alt || "Utøverprofil"}
            className="w-full max-w-md"
          />
          {photoCredit && (
            <Paragraph data-size="sm" className="mt-2 text-gray-600">
              {translation.photocredit}: {photoCredit}
            </Paragraph>
          )}
        </div>
      )}

      <div className="flex flex-col w-full gap-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {club && (
            <div>
              <Paragraph className="font-semibold inline">
                {translation.club}:
              </Paragraph>
              {club.url ? (
                <Link href={club.url}>{club.text}</Link>
              ) : (
                <Paragraph>{club.text}</Paragraph>
              )}
            </div>
          )}

          {team && (
            <Paragraph className="font-normal">
              <span className="font-semibold">{translation.team}:</span>
              {team}
            </Paragraph>
          )}

          {birthDate && (
            <Paragraph className="font-normal">
              <span className="font-semibold">{translation.birthdate}:</span>
              {birthDate}
            </Paragraph>
          )}

          {homeTown && (
            <Paragraph className="font-normal">
              <span className="font-semibold">{translation.hometown}:</span>
              {homeTown}
            </Paragraph>
          )}

          {residentTown && (
            <Paragraph className="font-normal">
              <span className="font-semibold">{translation.residenttown}:</span>
              {residentTown}
            </Paragraph>
          )}

          {email && (
            <Paragraph className="font-normal">
              <span className="font-semibold">{translation.email}:</span>
              <Link href={`mailto:${email}`}>{email}</Link>
            </Paragraph>
          )}

          {jobTitle && (
            <Paragraph className="font-normal">
              <span className="font-semibold">{translation.jobtitle}:</span>
              {jobTitle}
            </Paragraph>
          )}

          {phoneNumber && (
            <Paragraph className="font-normal">
              <span className="font-semibold">{translation.phonenumber}:</span>
              <Link href={`tel:${phoneNumber}`}>{phoneNumber}</Link>
            </Paragraph>
          )}
        </div>

        {(fisAthleteId || fisAthleteSectorValue) && (
          <div>
            <Heading level={2} data-size="lg" className="mb-4">
              {translation.fisinformation}
            </Heading>
            {fisAthleteId && (
              <Paragraph className="font-normal">
                <span className="font-semibold">
                  {translation.fisathleteid}:
                </span>
                {fisAthleteId}
              </Paragraph>
            )}
            {fisAthleteSectorValue && (
              <Paragraph className="font-normal">
                <span className="font-semibold">
                  {translation.fisathletesectorvalue}:
                </span>
                {fisAthleteSectorValue}
              </Paragraph>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default AthleteProfilePage;
